


















































































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { Equalize } from '@empathybroker/tsclient-play/dist/models/equalize';
import { CatalogFieldConfig } from '@empathybroker/tsclient-play/dist/models/instance/catalog-field-config';

import {
  CrudForm,
  ProductsSearch,
  Slider,
  Tabs,
  TransitionHeight,
  UiAlert,
  UiButton,
  UiIcon,
  UiSwitch,
  UiTextbox
} from '../../components';

import { DeviceEnum, FilterTypeEnum, GridDisplayEnum } from '../../enums';

import { capitalizeSentence } from '../../filters';

import { CrudFormMixin } from '../../mixins/crud-form.mixin';

import { Dictionary, EnabledFieldConfig, Filter, RegularFilter } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

export enum EqualizeTabModes {
  CONFIGURATION = 'configuration',
  PREVIEW = 'preview'
}

export default {
  name: 'equalize-form',
  components: {
    ProductsSearch,
    CrudForm,
    Slider,
    UiButton,
    UiTextbox,
    UiSwitch,
    UiAlert,
    UiIcon,
    Tabs,
    TransitionHeight
  },
  mixins: [CrudFormMixin],
  computed: {
    valid: function (): boolean {
      if (!this.item.title) {
        return false;
      }
      if (this.item.fields.every((field: any) => !field.value)) {
        return false;
      }
      return true;
    },
    enabledFieldDisabled: function () {
      const stateItem = this.state.data.find((item: Equalize) => (item.id === this.item.id));
      return (!!stateItem ? stateItem.enabled : false);
    },
    enabledFieldConfig: function (): EnabledFieldConfig {
      return {
        disabled: this.enabledFieldDisabled,
        alertConfig: {
          type: 'info',
          message: this.messages.fields.enabled.alert
        }
      };
    },
    searchableFieldsConfig: function (): CatalogFieldConfig[] {
      return this.instanceConfig.catalog.fields.filter((fieldConfig: CatalogFieldConfig) => fieldConfig.searchable);
    },
    notesBtnText: function () {
      return this.notesShown ? this.messages.fields.notes.actions.hide : this.messages.fields.notes.actions.show;
    },
    productSearchProps: function () {
      return {
        filters: this.searchFilters,
        searchParams: this.searchParams,
        gridItemsPerRow: this.itemsPerRow,
        componentsVisibility: { filters: true, textbox: true, keywords: false },
        messages: this.messages
      };
    },
    configurationTabs: function () {
      return Object.values(EqualizeTabModes).map(mode => ({
        id: mode,
        icon: this.getEqualizeTabIcon(mode),
        text: (this.$epb.device > DeviceEnum.SMALL_TABLET ? this.getEqualizeTabTitle(mode) : undefined)
      }));
    },
    itemsPerRow: function () {
      const gridItems = {
        [DeviceEnum.DESKTOP]: {
          [GridDisplayEnum.BIG]: 3,
          [GridDisplayEnum.SMALL]: 2
        },
        [DeviceEnum.MOBILE]: {
          [GridDisplayEnum.BIG]: 2,
          [GridDisplayEnum.SMALL]: 1
        },
        'default': {
          [GridDisplayEnum.BIG]: 4,
          [GridDisplayEnum.SMALL]: 3
        }
      };
      return (gridItems[this.$epb.device] || gridItems['default']);
    }
  },
  data: function () {
    return {
      dataType: ActionTypeEnum.EQUALIZE,
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.equalize.update),
      item: {
        enabled: false,
        title: undefined,
        notes: undefined,
        fields: []
      },
      searchFilters: {},
      searchParams: {
        equalize: ''
      },
      searchRequestTimeout: undefined,
      selectedConfigMode: EqualizeTabModes.CONFIGURATION,
      messages: this.$epb.messages.tools.equalize,
      notesShown: false,
      GridDisplayEnum,
      EqualizeTabModes,
      capitalizeSentence
    };
  },
  created: function () {
    const filters: Dictionary<RegularFilter> = {};
    Object.values(this.context.filters)
      .filter((filter: Filter) => (filter.config.type === FilterTypeEnum.REGULAR))
      .forEach((filter: RegularFilter) => {
        filters[(filter.config.toolingId || filter.config.id)] = {
          config: {
            ...filter.config,
            mandatory: true,
            multiselectDisabled: true
          },
          selectedValues: [filter.config.values[0].id]
        };
      });
    this.searchFilters = filters;

    this.searchableFieldsConfig.forEach((fieldConfig: CatalogFieldConfig) => {
      if (!this.item.fields.some((field: any) => (field.id === fieldConfig.id))) {
        this.item.fields.push({
          id: fieldConfig.id,
          value: 0
        });
      }
    });
  },
  methods: {
    getFieldValue: function (fieldConfig: CatalogFieldConfig) {
      const itemField = this.item.fields.find((field: any) => (field.id === fieldConfig.id));
      if (!!itemField) {
        return itemField.value;
      } else {
        return 0;
      }
    },
    setFieldValue: function (value: number, fieldConfig: CatalogFieldConfig) {
      const itemField = this.item.fields.find((field: any) => (field.id === fieldConfig.id));
      if (!!itemField) {
        itemField.value = value;
      } else {
        this.item.fields.push({
          id: fieldConfig.id,
          value: value
        });
      }
    },
    setSearchParams: function () {
      const equalizeFields = {};
      this.item.fields.map(field => equalizeFields[field.id] = field.value);
      this.searchParams.equalize = encodeURIComponent(JSON.stringify(equalizeFields));
    },
    onChangeSearchFilter: function (filter: { filterId: string, newValue: string }) {
      this.searchFilters[filter.filterId].selectedValues = filter.newValue;
    },
    getEqualizeTabIcon: function (mode: EqualizeTabModes): string {
      return {
        [EqualizeTabModes.CONFIGURATION]: 'equalize',
        [EqualizeTabModes.PREVIEW]: 'preview'
      }[mode];
    },
    getEqualizeTabTitle: function (mode: EqualizeTabModes): string {
      return {
        [EqualizeTabModes.CONFIGURATION]: this.messages.fieldValues,
        [EqualizeTabModes.PREVIEW]: this.messages.preview
      }[mode];
    }
  },
  watch: {
    'item.fields': {
      handler: function () {
        this.setSearchParams();
      },
      deep: true
    }
  }
};

